export function changeSeoData(data, matchDetail, type) {
  return {
    ...data,
    sTitle: makeTitle(matchDetail, type),
    sDescription: makeDescription(matchDetail, type),
    aKeywords: getKeywords(matchDetail, data, type),
    sRobots: getRobots(matchDetail, data, type)
  }
}

function getRobots(match, seo, type) {
  if (type === 'news' || type === 'fantasy-tips' || type === 'live-blog' || type === 'shorts') return 'Noindex, Follow'
  else return seo?.sRobots
}

function getKeywords(match, data, type) {
  const matchShortName = `${match?.oTeamScoreA?.oTeam?.sAbbr} vs ${match?.oTeamScoreB?.oTeam?.sAbbr}`
  if (type === 'squads') {
    if (match?.sStatusStr === 'scheduled') {
      const matchFullName = `${match?.oTeamScoreA?.oTeam?.sTitle} vs ${match?.oTeamScoreB?.oTeam?.sTitle}`
      return [
        `${matchShortName} Squads`,
        `${matchFullName} squads`,
        `${match?.oSeries?.sAbbr || match?.oSeries?.sTitle} live team updates`,
        `${match?.oTeamScoreA?.oTeam?.sAbbr} squad today match`,
        `${match?.oTeamScoreB?.oTeam?.sAbbr} squad today match`,
        `${match?.oSeries?.sTitle || match?.oSeries?.sAbbr} live squads update`,
        `${match?.oTeamScoreA?.oTeam?.sTitle} squad today match`,
        `${match?.oTeamScoreB?.oTeam?.sTitle} squad today match`
      ]
    } else {
      return [
        `${matchShortName} playing XI`,
        `${match?.oTeamScoreA?.oTeam?.sAbbr} confirmed playing 11`,
        `${matchShortName} confirmed playing XI`,
        `${match?.oTeamScoreB?.oTeam?.sAbbr} final playing 11 today match`,
        `${match?.oTeamScoreA?.oTeam?.sTitle} Playing 11`,
        `${match?.oTeamScoreA?.oTeam?.sTitle} Playing XI`,
        `${match?.oTeamScoreB?.oTeam?.sTitle} Playing XI`,
        `${match?.oTeamScoreB?.oTeam?.sTitle} Playing 11`
      ]
    }
  } else return data?.aKeywords
}

function makeTitle(match, type) {
  const matchShortName = `${match?.oTeamScoreA?.oTeam?.sAbbr} vs ${match?.oTeamScoreB?.oTeam?.sAbbr}`
  const matchFullName = `${match?.oTeamScoreA?.oTeam?.sTitle} vs ${match?.oTeamScoreB?.oTeam?.sTitle}`

  if (type === 'full-scorecard') {
    return `${matchFullName} ${match?.sSubtitle} ${match?.oSeries?.sSeason} Full Scorecard & Updates`
  } else if (type === 'news') {
    return `${matchShortName} ${match?.oSeries?.sSeason} Latest News | Live Match Updates,  Match previews, Predictions & Match results`
  } else if (type === 'overs') {
    return `${matchShortName} Overs | ${matchFullName} Full over & Ball by Ball updates`
  } else if (type === 'fixtures-and-results') {
    return `${matchShortName} ${match?.oSeries?.sSeason} Schedule | Fixtures, Upcoming schedule & Match Details`
  } else if (type === 'results') {
    return `${matchShortName} ${match?.oSeries?.sSeason} Results After ${match?.nLatestInningNumber} | Yesterday's ${matchShortName} Match Results`
  } else if (type === 'squads') {
    if (match?.sStatusStr === 'scheduled') {
      return `${matchShortName} Squads | ${match?.sSubtitle}, ${match?.oSeries?.sAbbr || match?.oSeries?.sTitle} – Full Team List & Updates`
    } else {
      return `${matchShortName} Playing 11 | ${match?.sSubtitle}, ${
        match?.oSeries?.sAbbr || match?.oSeries?.sTitle
      } – Confirmed Playing XI & Updates`
    }
  } else {
    const { team1Abbr, team2Abbr, matchNo, team1Name, team2Name } = {
      team1Abbr: match?.oTeamScoreA?.oTeam?.sAbbr,
      team2Abbr: match?.oTeamScoreB?.oTeam?.sAbbr,
      matchNo: match?.sSubtitle,
      team1Name: match?.oTeamScoreA?.oTeam?.sTitle,
      team2Name: match?.oTeamScoreB?.oTeam?.sTitle
    }
    if (match?.sStatusStr === 'live' || match?.sStatusStr === 'completed' || match?.sStatusStr === 'cancelled') {
      return `${team1Abbr} vs ${team2Abbr} Live Score${
        matchNo ? `, ${matchNo}` : ''
      } | ${team1Name} vs ${team2Name} ${matchNo} Live Score & Ball by Ball Commentary Updates`
    } else {
      return `${team1Abbr} vs ${team2Abbr} Live Score${
        matchNo ? `, ${matchNo}` : ''
      } | ${team1Name} vs ${team2Name} Score & Updates of ${matchNo}`
    }
  }
}

function makeDescription(match, type) {
  const matchName = `${match?.oTeamScoreA?.oTeam?.sAbbr} vs ${match?.oTeamScoreB?.oTeam?.sAbbr}`
  const matchFullName = `${match?.oTeamScoreA?.oTeam?.sTitle} vs ${match?.oTeamScoreB?.oTeam?.sTitle}`

  if (type === 'full-scorecard') {
    return `${matchName} ${match?.sSubtitle} ${match?.oSeries?.sSeason} Full Scorecard: Get the live & detailed ${matchName} ${match?.sSubtitle} ${match?.oSeries?.sSeason} scorecard, players score & fall of wickets information on CricTracker.`
  } else if (type === 'news') {
    return `${matchName} ${match?.oSeries?.sSeason} : Check out the ${matchName} Latest news, Injury updates, fantasy tips, Match predictions & More on CricTracker`
  } else if (type === 'overs') {
    return `${matchName} Overs: Get the detailed ${matchName} ${match?.sFormatStr} Live Over updates, Ball by Ball, & Match updates only on CricTracker`
  } else if (type === 'fixtures-and-results') {
    return `${matchName} ${match?.oSeries?.sSeason}: Check out the ${matchName} Latest schedule, Fixtures, Teams, Date, Timings, Upcoming schedule & more on CricTracker`
  } else if (type === 'results') {
    return `${matchName} ${match?.oSeries?.sSeason} Results: Check out the latest ${matchName} ${match?.oSeries?.sSeason} match results after ${match?.sSubtitle} with scorecard, stats and other match details on CricTracker`
  } else if (type === 'squads') {
    if (match?.sStatusStr === 'scheduled') {
      return `${matchName} Squads: Check the full squad for ${matchFullName}, ${match?.sSubtitle} of ${match?.oSeries?.sTitle} ${match?.oSeries?.sSeason} only on CricTracker`
    } else {
      return `${matchName} Playing 11: Get the confirmed playing XI for ${matchFullName}, ${match?.sSubtitle} of ${match?.oSeries?.sTitle} ${match?.oSeries?.sSeason} only on CricTracker`
    }
  } else {
    const { team1Abbr, team2Abbr, matchNo } = {
      team1Abbr: match?.oTeamScoreA?.oTeam?.sAbbr,
      team2Abbr: match?.oTeamScoreB?.oTeam?.sAbbr,
      matchNo: match?.sSubtitle
    }
    return `${team1Abbr} vs ${team2Abbr} ${matchNo}, Live Score: Get all the latest ${team1Abbr} vs ${team2Abbr} Live Score of ${matchNo} along with ball by ball commentary & updates on CricTracker.`
  }
}
